/* eslint-disable @typescript-eslint/lines-between-class-members */
export default class PaginationConstants {
    static readonly RegularPageSize = 10;
    static readonly InitialOffset = 0;
}
